import {Pipe, PipeTransform} from "@angular/core";
import {ClientInstallReferrer, Club, ClubList, Contact, Default, License, Property} from "../services/pinhole.user.service";

@Pipe({
    name: 'PropertyType',
    standalone: true
})
export class PropertyTypePipe implements PipeTransform {
    transform<T extends Property>(
        value: Property,
        expect: 'Contact'
    ): Contact | null;
    transform<T extends Property>(
        value: Property,
        expect: 'License'
    ): License | null;
    transform<T extends Property>(
        value: Property,
        expect: 'ClientInstallReferrer'
    ): ClientInstallReferrer | null;
    transform<T extends Property>(
        value: Property,
        expect: 'Club'
    ): Club | null;
    transform<T extends Property>(
        value: Property,
        expect: 'ClubList'
    ): ClubList | null;

    transform<T extends Property>(
        value: Property,
        expect: 'Default'
    ): Default | null;

    transform(
        value: Property,
        expect: string
    ): Property | null {
        if (value?.type === expect) {
            return value;
        }
        return null;
    }
}
